import { NavLink } from "react-router";

import parse from 'html-react-parser';
import type { Reglements } from "../../types/Reglements";
import { useTrads } from "../../contexts/trads/useTrads";
import { useAuth } from '../../contexts/auth/useAuth';
import { roles } from '../../types/Users';
import { formatDate } from "../../tools/utils";

function ReglementsItem({reglement}:{reglement:Reglements}) {
    const {translate}=useTrads();
    const {  hasRole } = useAuth();

    return (
        <div className="row">
            <div className="col-12">
                {parse(reglement.texte)}
            </div>
            {reglement.date_modif?
            <footer  className="col-12">
                {translate('reglement_derniere_modif')} {formatDate(reglement.date_modif,{
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                    hour12: false,
                    })}
            </footer>
            :null}
            {hasRole(roles.Administrators) ?
                <NavLink to={`/reglements/${reglement.id.toString()}/edit`}> {translate('btn_edit')}</NavLink>
            :null}
        </div>
    );
}
export default ReglementsItem;